import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { Table, Spin } from 'antd';

import * as Styled from './style.js';
import { getData } from '../../config/api-connect';
import Spinner from '../../components/spinner';
import { Link } from 'react-router-dom';

import { Dropdown, Menu } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { Form, Input, Button, InputNumber } from 'antd';
import { message } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined, EyeOutlined, EyeInvisibleOutlined ,ArrowRightOutlined} from '@ant-design/icons';
import { Select, Tag } from 'antd';
import AddJob from "./addJob";
import './style.css'


const Careers = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [jobData, setJobData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;
  const departments_list = ['Engineering', 'Customer Support', 'Graphic Designers', 'Finance', 'Marketing', 'Coaching', 'Others'];
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    getJobListings();
  }, []);

  const handleUpdate = (record) => {
	  setSelectedJob(record);
	  form.setFieldsValue({title: record.title,
    location: record.location,
    description: record.description,
    contact_no: record.contact_no,
    contact_email: record.contact_email,
    minimum_qualification: record.minimum_qualification,
    experience: record.experience,
    department: record.department,
    no_of_openings: record.no_of_openings,}); 
	  setIsModalVisible(true);
	};

  const handleFormSubmit = () => {
	  form.validateFields()
	    .then(values => {
	      setLoading(true);
	      getData(`/career/update_job/?id=${selectedJob.id}&title=${values.title}&location=${values.location}`)
	        .then(() => {
	          const updatedDepartmentLabel = departments.find(
				  (dept) => dept.value === values.department
				)?.label || values.department;

				setJobData(prev =>
				  prev.map(job =>
				    job.id === selectedJob.id
				      ? { ...job, ...values, department: updatedDepartmentLabel, department_label: updatedDepartmentLabel }
				      : job
				  )
				);

	          setLoading(false);
	          setIsModalVisible(false);
	          message.success(`Updated successfully`, 2);
	        })
	        .catch(err => {
	          console.error(err);
	          setLoading(false);
	          message.error("Update failed. Please try again.");
	        });
	    });
	};


	const handleToggleStatus = (record) => {
	  const newStatus = record.status === 1 ? 2 : 1;

	  Modal.confirm({
	    title: record.status === 1 ? 'Confirm Unpublish?' : 'Confirm Publish?',
	    content:
	      record.status === 1
	        ? `On unpublishing, the job "${record.title}" will be removed from the careers page of website.`
	        : `On publishing, the job "${record.title}" will be available on the careers page of website.`,
	    okText: 'Yes',
	    cancelText: 'No',
	    onOk() {
	      setLoading(true);
	      getData(`/career/toggle_job_status/?job_id=${record.id}&status=${newStatus}`)
	        .then(() => {
	          setJobData(prev =>
	            prev.map(job =>
	              job.id === record.id ? { ...job, status: newStatus } : job
	            )
	          );
	          message.success(`"${record.title}" ${newStatus === 1 ? 'published' : 'unpublished'} successfully`, 2);
	        })
	        .catch((err) => {
	          console.error(err);
	          message.error('Failed to update status', 2);
	        })
	        .finally(() => {
	          setLoading(false);
	        });
	    },
	  });
	};


 const handleDelete = (record) => {
	Modal.confirm({
    title: 'Are you sure ?',
    content: `Delete job : ${record.title}?`,
    okText: 'Yes',
    cancelText: 'No',
    onOk() {
      setLoading(true);
      getData(`/career/delete_job/?job_id=${record.id}`)
        .then(() => {
          setJobData(prev => prev.filter(job => job.id !== record.id));
          setLoading(false);
          message.success(`"${record.title}" deleted successfully`, 2);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          message.error("Failed to delete", 2);
        });
    }
  });
  };

  const handleAddJob = () => {
	  form.validateFields()
	    .then(values => {
	      setLoading(true);
	      getData(`/career/add_job/?title=${values.title}&location=${values.location}&department=${values.department}&no_of_openings=${values.no_of_openings}`)
	        .then(() => {
	          message.success("Job added successfully", 2);
	          setIsAddModalVisible(false);
	          getJobListings(); 
	          setLoading(false);
	        })
	        .catch(err => {
	          console.error(err);
	          message.error("Failed to add job");
	          setLoading(false);
	        });
	    });
	};

 
  const getJobListings = () => {
    setLoading(true);
    getData('/career/get_jobs_for_business_portal/')
      .then(response => {
        const data = response.result;
        if (response && response.departments) {
		        setDepartments(response.departments);
		      }
        console.log("API Response:", response);
        const filteredData = data.map((job, index) => ({
          key: job.id,
  		  id: job.id,
          key: index,
          title: job.title || 'N/A',
          location: job.location || 'N/A',
          no_of_applicants: job.applicants || '-',
          no_of_openings: job.no_of_openings || '-',
          department: job.department_label || 'N/A',
          applicants: job.applicants || {},
      	  description: job.description || '',
		  contact_no: job.contact_no || '',
		  contact_email: job.contact_email || '',
		  minimum_qualification: job.minimum_qualification || '',
		  experience: job.experience || '',
		  departments: job.departments,
		  status: job.status || 2,
        }));
        console.log("Formatted Data for Table:", filteredData);
        setJobData(filteredData);
        setLoading(false);
      })
      .catch(error => {
        console.log("Fetch error:", error.message);
        setLoading(false);
      });
  };

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => (
	    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
	      <span>{text}</span>
	      {record.status !== 1 && (
	        <Tag color="magenta" style={{ marginLeft: 4 ,fontSize:"10px"}}>Not published</Tag>
	      )}
	    </div>
	  ),
    },
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
    },
    {
		  title: 'No of Applicants',
		  dataIndex: 'no_of_applicants',
		  key: 'no_of_applicants',
		  align: 'center',
		  sorter: (a, b) => (a.no_of_applicants || 0) - (b.no_of_applicants || 0),
		  render: (text, record) => {
		    const isJobApplicants = text !== "-" && text >= 1;
		    return isJobApplicants ? (
		      <Link
		        to={`/careers/${record.id}`}
		        state={{ job: record }}
		        className="applicants-link"
		      >
		        <span>{text}</span>
		        <ArrowRightOutlined className="arrow-icon" />
		      </Link>
		    ) : (
		      <span style={{ color: '#999' }}>{text}</span>
		    );
		  }
		},

    {
	  title: 'No of Openings',
	  dataIndex: 'no_of_openings',
	  key: 'no_of_openings',
	  align: 'center',
	  sorter: (a, b) => (a.no_of_openings || 0) - (b.no_of_openings || 0),
	},
	// {
	//   title: 'Actions',
	//   key: 'actions',
	//   align: 'center',
	//   width: 100,
	//   render: (_, record) => {
	//   	const isPublished = record.status === 1;
	//     const menu = (
	//       <Menu>
	//         <Menu.Item key="edit" icon={<EditOutlined />} onClick={() => handleUpdate(record)}>
	//           Edit
	//         </Menu.Item>
	//         <Menu.Item key="delete" icon={<DeleteOutlined />} onClick={() => handleDelete(record)}>
	//           Delete
	//         </Menu.Item>
	//        <Menu.Item
	//           key="toggle"
	//           icon={isPublished ? <EyeInvisibleOutlined /> : <EyeOutlined />}
	//           onClick={() => handleToggleStatus(record)}
	//         >
	//           {isPublished ? 'Unpublish' : 'Publish'}
	//         </Menu.Item>
	//       </Menu>
	//     );

	//     return (
	//       <Dropdown overlay={menu} trigger={['click']}>
	//         <MoreOutlined style={{ fontSize: '18px', cursor: 'pointer' }} />
	//       </Dropdown>
	//     );
	//   }
	// }
	{
	  title: 'Actions',
	  key: 'actions',
	  align: 'center',
	  width:90,
	  render: (_, record) => (
	    <EditOutlined
	      onClick={() =>
	        navigate(`/careers/edit/${record.id}`, {
	          state: { job: record, departments }
	        })
	      }
	      style={{ fontSize: '18px'}}
	      title="Edit Job"
	      className="venueTitle"
	    />
	  ),
	}
  ];

   <Modal
	  title={`Edit Job - ${selectedJob?.title}`}
	  visible={isModalVisible}
	  onCancel={() => setIsModalVisible(false)}
	  onOk={handleFormSubmit}
	  okText="Save"
	>
	  <Form form={form} layout="vertical">
	    <Form.Item name="title" label="Title" rules={[{ required: true, message: 'Please enter title' }]}>
	      <Input />
	    </Form.Item>
	    <Form.Item name="location" label="Location" rules={[{ required: true, message: 'Please enter location' }]}>
	      <Input />
	    </Form.Item>
	    <Form.Item name="department" label="Department">
	      <Input />
	    </Form.Item>
	    <Form.Item name="no_of_openings" label="No of Openings">
	      <Input />
	    </Form.Item>
	  </Form>
	</Modal>

  return (

  <Spin spinning={loading} indicator={<Spinner />}>
    <Styled.MainContainer>
      <Styled.Header>
      	<span></span>
		  	<div>Careers</div>
			  <Button type="primary" icon={<PlusOutlined />}
			    onClick={() => navigate('/careers/add',{ state: { departments } })}
			    style={{
			      backgroundColor: "#006d77",
			      color: "white",
			      borderColor: "#3c6e71",
			      borderRadius: '5px',
			      display: 'flex' , alignItems:'center'
			    }}
			  >
			    Add Job
			  </Button>
			</Styled.Header>

      <div className="recordCount">{jobData.length} records</div>

      <Table
        className="ant-table-thead table_container"
        // tableLayout="fixed"
        dataSource={jobData}
        columns={columns}
        pagination={{ pageSize: 100, showSizeChanger: false }}
      />
    </Styled.MainContainer>
  </Spin>
);

};

export default Careers;
